import React from "react";
import { useGame } from "context/GameContext";
import Table from "./table";

const Bag = () => {
  const { gameState, setGameState } = useGame();
  const { party } = gameState;

  const { resources, phase } = party;
  const { attribs, weight, isVisible } = resources;

  const resetWarning = () => {
    setGameState((prevState) => {
      let newState = { ...prevState };
      newState.party.resources.weight.overweight = false;
      return newState;
    });
  };

  const data = Object.keys(attribs)
    .map((key) => {
      const resource = attribs[key];
      if (!resource.isCarried || !isVisible(phase, resource)) return null;

      return {
        ...resource,
        tooltip: resource.tooltip(gameState),
        buttons: null,
      };
    })
    .filter((e) => e);

  return data.length
    ? (
      <Table
        data={data}
        summaryLabel={weight.label}
        summaryTotal={weight.current}
        summaryMax={weight.max}
        summaryTotalWarning={weight.overweight}
        resetWarning={resetWarning}
      />
    )
    : null;
};

export default Bag;
